// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"HeroBanner_bannerImage__VjzGq"};